import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation,  Input  } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from 'rxjs';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { AbiertasService } from "../../services/abiertas.service";
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

export interface Respuesta {
 success: any,
 abiertaUpdate:{
   obligatorio: any,
   tipoAgregado:any,
   vivoAbierta:any,
   traducciones:any,
   _id:any,
   pregunta:any,
   orden:any
 }
}

@Component({
  selector: 'open',
  templateUrl: './open.component.html',
  styleUrls: ['./open.component.scss']
})
export class OpenComponent implements OnInit {
  @Input('pasoCompleto') pasoCompleto?: boolean;
  abiertas: any = [];
  // pasoCompleto?: boolean;
  constructor(private abiertasService: AbiertasService,
      private wizardService: WizardService,
      public snackBar: MatSnackBar,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private serviceTranslate: TranslateService) {
      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
  }

  ngOnInit() {
    this.obtieneInstituto();
    this.getAbiertas();
  }
  instituto:any;
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Open "+this.instituto);
  }


  public getAbiertas(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.abiertasService.getAbiertas(data)
    .subscribe(response => {
      console.log(response);
      if(response['success'] == true){
        if(response['abiertas'].length > 0){
          this.abiertas = response['abiertas'];
        }else{
          this.insertaAbiertas();
        }

      }

    }, error => {
      console.log("error", error);
    });
  }

  public insertaAbiertas(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.abiertasService.insertaCatalogoAbiertas(data)
    .subscribe(response => {
      if(response['success'] == true){
        this.abiertas = response['abiertas'];
      }

    }, error => {
      console.log("error", error);
    });
  }

  agregaPregunta(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      orden: this.abiertas[this.abiertas.length-1].orden+1,
      pregunta: "",
      tipoAgregado: 0
    }
    this.abiertasService.saveAbiertas(data)
    .subscribe(response => {
      console.log(response);
      if(response['success'] == true){
        this.abiertas.push({
          obligatorio: 0,
          orden: this.abiertas[this.abiertas.length-1].orden+1,
          pregunta: "",
          traducciones: [],
          vivoReactivo: 1,
          _id: response['newAbierta']['_id']
        });
      }

    }, error => {
      console.log("error", error);
    });
  }

  onBlurPregunta(event,pregunta){
    if(event.target.value.length > 0){
      let data = {
          fechaCertificar: localStorage.getItem('fechaProducto'),
          idAbierta: pregunta._id,
          pregunta: event.target.value
      };
      this.abiertasService.updateAbiertas(data)
      .subscribe((response:Respuesta) => {
        console.log(response);
        if(response.success == true){
          this.abiertas.forEach(element => {
            if(element._id==response.abiertaUpdate._id){
              element.pregunta=response.abiertaUpdate.pregunta;
            }
          });

          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'),this.serviceTranslate.instant('ALERTS.OK'));

        }

      }, error => {
        console.log("error", error);
      });
      //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));

    }else{
      this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDFAIL'),this.serviceTranslate.instant('ALERTS.OK'));
    }
  }

  deletePregunta(event,pregunta){
      let data = {
          fechaCertificar: localStorage.getItem('fechaProducto'),
          idAbierta: pregunta._id
      };
      this.abiertasService.deleteAbiertas(data)
      .subscribe(response => {
        console.log(response);
        if(response['success'] == true){
          this.getAbiertas();
          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'),this.serviceTranslate.instant('ALERTS.OK'));

        }

      }, error => {
        console.log("error", error);
      });
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }

}
